'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _deprecated = require('react-utils/decorators/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UICard = _react2.default.createClass({
  displayName: 'UICard',

  propTypes: _extends({}, _UISection2.default.propTypes, {
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    compact: _react.PropTypes.bool.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UISection2.default.defaultProps, {
      compact: false
    });
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        compact = _props.compact,
        other = _objectWithoutProperties(_props, ['children', 'className', 'compact']);

    return _react2.default.createElement(
      _UISection2.default,
      _extends({}, other, {
        className: (0, _reactUtils.classNames)('private-card', { 'private-card--compact': compact }, className)
      }),
      children
    );
  }
});

exports.default = (0, _deprecated2.default)('Use UICardWrapper instead.', 'https://git.hubteam.com/HubSpot/UIComponents/pull/682')(UICard);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/card/UICard.js
// module id = 59
// module chunks = 0